import * as _ from 'lodash';

export const types = {
    3: 'project-icon',  //project
    2: 'project-group-icon',   //group
    1: 'users-icon'   //global
};

export const TranformtionEnforcmentServerToClientFilterObject = {
    "name": "enforcementServerToClient",
    "filter": [() => {
        return (inputJson,metaData) => {
            let outputJson = [];
            outputJson.MetaData = {
                actions: metaData.actions,
            };
            if (inputJson.length > 0) {
                _.each(inputJson, (scopeItem) => {
                    scopeItem.name = scopeItem.scopeName;
                    scopeItem.icon = types[scopeItem.scopeTypeId];
                   // scopeItem.scopeName = scopeItem.scopeName;
                    outputJson.push(scopeItem);
                })
            }
            return [outputJson];
        };
    }]
};



// WEBPACK FOOTER //
// ./src/app/authorized/policyEngine/transofromtions/trans.enforcmentServerToClient.js